export class AuthorizationError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
